import { useEffect, useState } from 'react';

import { TabList } from '../../shared/ui';

export interface ITab {
  id: string;
  title: string;
  content: React.ReactNode;
  isActive?: boolean;
  disabled?: boolean; // Новое поле для disabled состояния
}

export interface ITabsProps {
  tabs: ITab[];
  defaultActiveId?: string;
  activeId?: string;
  onChange?: (id: string) => void;
  navigationClassName?: string;
}

export const Tabs = ({ tabs, defaultActiveId, activeId, onChange, navigationClassName }: ITabsProps) => {
  // Фильтруем неотключенные табы для выбора активного
  const enabledTabs = tabs.filter((tab) => !tab.disabled);
  const initialActiveTab =
    (defaultActiveId && enabledTabs.find((tab) => tab.id === defaultActiveId)) ||
    enabledTabs.find((tab) => tab.isActive) ||
    enabledTabs[0];
  const [activeTab, setActiveTab] = useState(initialActiveTab?.id);
  const currentActiveTab = activeId ?? activeTab;

  useEffect(() => {
    if (activeId !== undefined) return;
    if (!defaultActiveId) return;
    setActiveTab(defaultActiveId);
  }, [activeId, defaultActiveId]);

  const handleTabChange = (tabId: string) => {
    if (activeId === undefined) {
      setActiveTab(tabId);
    }
    onChange?.(tabId);
  };

  return (
    <div className="w-full h-full">
      <TabList
        items={tabs.map((tab) => ({ id: tab.id, label: tab.title, disabled: tab.disabled }))}
        value={currentActiveTab}
        onChange={handleTabChange}
        className={navigationClassName}
      />

      {/* Контент табов */}
      <div className="py-6">
        {tabs.map((tab) => (
          <div key={tab.id}>
            {!tab.disabled && currentActiveTab === tab.id && <div className="animate-fade-in">{tab.content}</div>}
          </div>
        ))}
      </div>
    </div>
  );
};
